import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { Switch, Route, BrowserRouter, Link } from "react-router-dom";
import ForgotPassword from "./Components/Login/ForgotPassword";
import store from "./Redux/Store";
import "./index.css";
import Sidebar from "../src/Components/SideBar/Sidebar";
import Thanks from "./Thanks";
import ThanksHubspot from "./ThanksHubspot";
import Login from "./Components/Login/Login";
import NotFound from "./NotFound";

// import ForgotPassword from "./Components/Login/ForgotPassword";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/forgotpassword" component={ForgotPassword} />
        {localStorage.getItem("token") !== null ? (
          window.location.pathname !== "/Salesforcethanks" &&
          window.location.pathname !== "/Hubspotthanks" ? (
            <Route path="/" component={Sidebar} />
          ) : (
            <>
              <Route exact path="/Hubspotthanks" component={ThanksHubspot} />
              <Route exact path="/Salesforcethanks" component={Thanks} />
            </>
          )
        ) : (
          <Route path="/" component={Login} />
        )}
      </Switch>
    </BrowserRouter>
  </Provider>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
